/* Congruent LP „Not normal” (01.11.2026): przyciski .js-nn-go przewijają do boxu zakupu (hm-ef-buy, #buy-sheet), koło
   [data-nn-spin] odkrywa karty i „Claim my box” zaznacza plan (zakładka [data-ptab] + radio hm_plan[data-key] + zdarzenie change,
   bez zmian w hm-ef-buy.js), a ciche pętle kroków (video.nn-vid) grają tylko w widoku. Tylko textContent, hidden i src wideo.
   Zdarzenia Clarity (nn_cta_*, nn_spin, nn_claim) i znacznik lp, gdy Clarity jest. */
(function () {
  var RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  function clar() { try { if (typeof window.clarity === 'function') window.clarity.apply(null, arguments); } catch (e) {} }
  function box() { return document.getElementById('buy-sheet') || document.getElementById('buy'); }
  // Cel przycisków: rząd zakładek planów w boxie (Subscribe & Save / One Time), żeby po kliknięciu od razu było widać plany,
  // a nie galerię na górze boxu (pomiar 01.11: plany 1 150–1 470 px pod górą boxu). Pod nagłówkiem sklepu, z odstępem na plakietkę.
  function cel() {
    var t = document.querySelector('[data-hm-buy-section] [data-ptab]');
    return (t && t.parentElement) || box();
  }
  function naglowek() { // wysokość przyklejonego nagłówka sklepu (przykleja się sekcja-opakowanie, nie sam <header>)
    var h = document.querySelector('header');
    for (var e = h; e && e !== document.body; e = e.parentElement) {
      var pos = getComputedStyle(e).position;
      if (pos === 'sticky' || pos === 'fixed') return e.offsetHeight;
    }
    return 0;
  }
  function go() {
    var t = cel();
    if (!t) return;
    scrollTo({ top: t.getBoundingClientRect().top + scrollY - naglowek() - 28, behavior: RM ? 'auto' : 'smooth' });
  }
  function pick(key) {
    var r = document.querySelector('input[name="hm_plan"][data-key="' + key + '"]');
    if (!r) return;
    var card = r.closest('[data-tab]');
    if (card) {
      var tab = document.querySelector('[data-ptab="' + card.getAttribute('data-tab') + '"]');
      if (tab && !tab.classList.contains('on')) tab.click();
    }
    if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.js-nn-go');
    if (!a) return;
    e.preventDefault();
    clar('event', a.getAttribute('data-ev') || 'nn_cta');
    go();
  });
  function spin(root) {
    if (!root || root.getAttribute('data-nn-init')) return;
    root.setAttribute('data-nn-init', '1');
    var cards = [].slice.call(root.querySelectorAll('.nn-card')),
      btn = root.querySelector('.js-nn-spin'), claim = root.querySelector('.js-nn-claim'),
      head = root.querySelector('.nn-spin-h'), status = root.querySelector('.nn-spin-status');
    if (!btn || !claim || !cards.length) return;
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-busy') === 'true' || root.classList.contains('won')) return;
      btn.setAttribute('aria-busy', 'true');
      if (btn.getAttribute('data-busy')) btn.textContent = btn.getAttribute('data-busy');
      clar('event', 'nn_spin');
      var i = 0, steps = RM ? 1 : 16;
      var t = setInterval(function () {
        cards.forEach(function (c, k) { c.classList.toggle('hot', k === i % cards.length); });
        i++;
        if (i < steps) return;
        clearInterval(t);
        cards.forEach(function (c, k) {
          c.classList.remove('hot');
          setTimeout(function () { c.classList.add('open'); }, RM ? 0 : k * 170);
        });
        setTimeout(function () {
          root.classList.add('won');
          var win = head && head.getAttribute('data-win');
          if (win) { head.textContent = win; if (status) status.textContent = win; }
          btn.hidden = true;
          claim.hidden = false;
          try { claim.focus({ preventScroll: true }); } catch (e) {}
        }, RM ? 0 : cards.length * 170 + 300);
      }, 105);
    });
    claim.addEventListener('click', function () {
      clar('event', 'nn_claim');
      pick(root.getAttribute('data-plan') || 'sub-two');
      setTimeout(go, 160); // hm-ef-buy trzyma klikniętą kartę w miejscu (apply keepPlace), więc przewijamy po jego korekcie
    });
  }
  // Ciche pętle kroków (video.nn-vid[data-src] nad plakatem img.nn-poster). Nic nie rusza przed zdarzeniem load (najpóźniej
  // 2,5 s), żeby pierwszy ekran miał całe łącze; potem plik pobiera się ok. 1200 px przed widokiem (preload auto), gra od wejścia
  // w widok, poza nim stoi, a widać go dopiero od pierwszej wyświetlonej klatki (klasa .on na „playing”), więc nie ma mignięcia.
  // Ograniczony ruch, oszczędzanie danych albo brak IntersectionObserver: zostaje plakat (najbardziej tłumacząca klatka pętli).
  var vload, vplay, vstart = false;
  function src(v) {
    if (v.getAttribute('src')) return;
    v.muted = true;
    v.preload = 'auto';
    v.addEventListener('playing', function () { v.classList.add('on'); });
    v.setAttribute('src', v.getAttribute('data-src'));
    try { v.load(); } catch (e) {}
  }
  function vids() {
    var oszcz = navigator.connection && navigator.connection.saveData;
    if (RM || oszcz || !('IntersectionObserver' in window)) return;
    vload = vload || new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { src(e.target); vload.unobserve(e.target); } });
    }, { rootMargin: '1200px 0px' });
    vplay = vplay || new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (!e.isIntersecting) { v.pause(); return; }
        src(v);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }, { threshold: 0.15 });
    [].forEach.call(document.querySelectorAll('video.nn-vid[data-src]'), function (v) {
      if (v.getAttribute('data-nn-v')) return;
      v.setAttribute('data-nn-v', '1');
      v.muted = true;
      vload.observe(v);
      vplay.observe(v);
    });
  }
  function startVids() { if (vstart) return; vstart = true; vids(); }
  function init() { [].forEach.call(document.querySelectorAll('[data-nn-spin]'), spin); }
  var lp = new URLSearchParams(location.search).get('lp');
  clar('set', 'lp', lp || 'b');
  init();
  if (document.readyState === 'complete') startVids();
  else { addEventListener('load', startVids); setTimeout(startVids, 2500); }
  document.addEventListener('shopify:section:load', function () { init(); if (vstart) vids(); });
})();
